import { api } from "services";
import { toast } from "sonner";

const ReportsView = ({ setReportLoading, type = "pdf" }) => {

  const handleDownload = async (numFY) => {
    setReportLoading((prev) => ({ ...prev, [type]: true }));
    const endMonth = new Date();
    let startMonth;

    if (numFY === "lifetime") {
      startMonth = "lifetime";
    } else {
      // startYear is (currentYear - (numFY - 1)) so:
      // 1 FY → 2025-2026, 2 FY → 2024-2026, 3 FY → 2023-2026
      startMonth = new Date();
      startMonth.setFullYear(endMonth.getFullYear() - numFY);
      startMonth.setHours(0, 0, 0, 0);
    }

    const result = await api.getFYReport(startMonth, endMonth, type);
    setReportLoading((prev) => ({ ...prev, [type]: false }));
    if (result == null) {
      toast.error("Download Failed, Please try again later.");
    }
  }

  return (
    <div className="dropdown">
      <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <li>
          <button className="dropdown-item" onClick={() => handleDownload(1)}>
            1 FY
          </button>
        </li>
        <li>
          <button className="dropdown-item" onClick={() => handleDownload(2)}>
            2 FY
          </button>
        </li>
        <li>
          <button className="dropdown-item" onClick={() => handleDownload(3)}>
            3 FY
          </button>
        </li>
        <li>
          <button className="dropdown-item" onClick={() => handleDownload("lifetime")}>
            Lifetime
          </button>
        </li>
      </ul>
    </div>
  );
};

export default ReportsView;